import React, { PropsWithChildren } from 'react';

import { DataGridProps, i18n, ThemedDataGrid } from '@fides/fides-react-components';
import { ColumnMapping, useDatasource } from './useDataSource';
import { I18nextProvider } from 'react-i18next';

export interface AwDataGridProps extends DataGridProps {
  url: string;
  angularScope: any;
  columnDefs: any;
  requestParams?: any;
  serializer?: any;
  columnMapping?: ColumnMapping;
  errorHandler?: any;
  lng?: string;
}

export const AwDataGrid = (props: PropsWithChildren<AwDataGridProps>) => {
  const {
    children,
    url = '',
    requestParams: params = {},
    serializer: paramsSerializer = {},
    columnMapping,
    errorHandler,
    columnDefs,
    lng,
    ...rest
  } = props;
  const datasource = useDatasource({
      url,
      params,
      paramsSerializer
    },
    params,
    columnMapping,
    errorHandler,
    columnDefs
  );
  // default number filtering
  const numberFilterParamsValues = {
    allowedCharPattern: '\\d\\.\\,\\-', filterOptions: ['equals', 'inRange'], suppressAndOrCondition: true };
  columnDefs.filter(col => col.filter === 'agNumberColumnFilter').forEach(col => col.filterParams = numberFilterParamsValues);

  return (
    <I18nextProvider i18n={i18n}>
      <ThemedDataGrid columnDefs={columnDefs} datasource={datasource} {...rest} />
    </I18nextProvider>
  );
}
